export const SITE_URL = "https://editing.video";

export const SITE_INFO = {
	title: "Editing.video",
	url: SITE_URL,
	openGraphImage: "/open-graph/default.jpg",
	twitterImage: "/open-graph/default.jpg",
	favicon: "/favicon.ico",
};

export const DEFAULT_LOGO_URL = "/logo.png";
